var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn tw-relative tw-flex tw-justify-center",on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[(! _vm.loading)?_c('span',[_vm._t("default")],2):_c('img',{staticClass:"spinner tw-absolute",attrs:{"src":"/img/loading.gif","width":"35"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }